import React from 'react';
import CONFIG from '../../../config';

// import WidgetInputText from '../../components/form_widgets/WidgetInputText';

import { useNavigate } from 'react-router-dom';
import axios from "axios";
import Button from '@mui/material/Button';
import { Chart } from "react-google-charts";
import WidgetCheckbox from '../../../components/widgets/WidgetCheckbox';
import WidgetDatePicker from '../../../components/widgets/WidgetDatePicker';
import dayjs from 'dayjs';

function isDateBetween(startDate, endDate, dateToCheck) {
  const start = startDate ? dayjs(startDate).startOf('day') : dayjs('2000-01-01');
  const end = endDate ? dayjs(endDate).startOf('day') : dayjs();

  if (!dateToCheck) {
    return true;
  }

  const date = dayjs(dateToCheck).startOf('day');

  return date.isBetween(start, end, null, '[]');
}


function Compta() {
  const navigate = useNavigate();

  const [TTC, setTTC] = React.useState(null);
  const [dateDebut, setDateDebut] = React.useState(null);
  const [dateFin, setDateFin] = React.useState(null);

  const [users, setUsers] = React.useState([]);
  const [ht, setHt] = React.useState(true);
  React.useEffect(() => {
    axios.get(CONFIG.API_URL + '/api/get_all_users', { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
      .then((response) => {
        switch (response.status) {
          case 200:
            setUsers(response.data);
            break;

          default:
            break;
        }
      })
      .catch((e) => {
        let response = e.response;

        if (response === undefined) {
          alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
          return;
        }

        switch (response.status) {
          default:
            alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
            break;
        }
      });
  }, []);

  console.log(users.filter(x => isDateBetween(dateDebut?.value, dateFin?.value, x.dossier.date_envoie)));

  const ca_previ_ht_montant = users.filter(x => isDateBetween(dateDebut?.value, dateFin?.value, x.dossier.date_envoie)).filter(x => (x.roles.role_client && x.dossier && (['envoye', 'valide'].includes(x.dossier.etat) || x.dossier.etat === 'archive'))).reduce((r, x) => {
    if (['envoye', 'valide'].includes(x.dossier.etat))
      return r + x.dossier.previ_montant;
    else
      return r + x.dossier.montant;
  }, 0);
  const ca_previ_ttc_montant = users.filter(x => isDateBetween(dateDebut?.value, dateFin?.value, x.dossier.date_envoie)).filter(x => (x.roles.role_client && (['envoye', 'valide'].includes(x.dossier.etat) || x.dossier.etat === 'archive'))).reduce((r, x) => {
    if (['envoye', 'valide'].includes(x.dossier.etat))
      return r + x.dossier.previ_montant * 1.2;
    else
      return r + x.dossier.montant * 1.2;
  }, 0);
  const ca_ht_montant = users.filter(x => isDateBetween(dateDebut?.value, dateFin?.value, x.dossier.date_envoie)).filter(x => (x.roles.role_client && x.dossier.etat === 'archive')).reduce((r, x) => {
    if (['envoye', 'valide'].includes(x.dossier.etat))
      return r + x.dossier.previ_montant;
    else
      return r + x.dossier.montant;
  }, 0);
  const ca_ttc_montant = users.filter(x => isDateBetween(dateDebut?.value, dateFin?.value, x.dossier.date_envoie)).filter(x => (x.roles.role_client && x.dossier.etat === 'archive')).reduce((r, x) => {
    if (['envoye', 'valide'].includes(x.dossier.etat))
      return r + x.dossier.previ_montant * 1.2;
    else
      return r + x.dossier.montant * 1.2;
  }, 0);

  const ca_previ_ht_presta = users.filter(x => isDateBetween(dateDebut?.value, dateFin?.value, x.dossier.date_envoie)).filter(x => (x.roles.role_client && (['envoye', 'valide'].includes(x.dossier.etat) || x.dossier.etat === 'archive'))).reduce((r, x) => {
    if (['envoye', 'valide'].includes(x.dossier.etat))
      return r + x.dossier.previ_presta;
    else
      return r + x.dossier.presta;
  }, 0);
  const ca_previ_ttc_presta = users.filter(x => isDateBetween(dateDebut?.value, dateFin?.value, x.dossier.date_envoie)).filter(x => (x.roles.role_client && (['envoye', 'valide'].includes(x.dossier.etat) || x.dossier.etat === 'archive'))).reduce((r, x) => {
    if (['envoye', 'valide'].includes(x.dossier.etat))
      return r + x.dossier.previ_presta * (x.dossier.presta_tva ? 1.2 : 1);
    else
      return r + x.dossier.presta * (x.dossier.presta_tva ? 1.2 : 1);
  }, 0);
  const ca_ht_presta = users.filter(x => isDateBetween(dateDebut?.value, dateFin?.value, x.dossier.date_envoie)).filter(x => (x.roles.role_client && x.dossier.etat === 'archive')).reduce((r, x) => {
    if (['envoye', 'valide'].includes(x.dossier.etat))
      return r + x.dossier.previ_presta;
    else
      return r + x.dossier.presta;
  }, 0);
  const ca_ttc_presta = users.filter(x => isDateBetween(dateDebut?.value, dateFin?.value, x.dossier.date_envoie)).filter(x => (x.roles.role_client && x.dossier.etat === 'archive')).reduce((r, x) => {
    if (['envoye', 'valide'].includes(x.dossier.etat))
      return r + x.dossier.previ_presta * (x.dossier.presta_tva ? 1.2 : 1);
    else
      return r + x.dossier.presta * (x.dossier.presta_tva ? 1.2 : 1);
  }, 0);

  const ca_previ_ht_promo_commercial = users.filter(x => isDateBetween(dateDebut?.value, dateFin?.value, x.dossier.date_envoie)).filter(x => (x.roles.role_client && (['envoye', 'valide'].includes(x.dossier.etat) || x.dossier.etat === 'archive'))).reduce((r, x) => {
    return r + x.dossier.promo_commercial;
  }, 0);
  const ca_previ_ttc_promo_commercial = users.filter(x => isDateBetween(dateDebut?.value, dateFin?.value, x.dossier.date_envoie)).filter(x => (x.roles.role_client && (['envoye', 'valide'].includes(x.dossier.etat) || x.dossier.etat === 'archive'))).reduce((r, x) => {
    return r + x.dossier.promo_commercial;
  }, 0);
  const ca_ht_promo_commercial = users.filter(x => isDateBetween(dateDebut?.value, dateFin?.value, x.dossier.date_envoie)).filter(x => (x.roles.role_client && x.dossier.etat === 'archive')).reduce((r, x) => {
    return r + x.dossier.promo_commercial;
  }, 0);
  const ca_ttc_promo_commercial = users.filter(x => isDateBetween(dateDebut?.value, dateFin?.value, x.dossier.date_envoie)).filter(x => (x.roles.role_client && x.dossier.etat === 'archive')).reduce((r, x) => {
    return r + x.dossier.promo_commercial;
  }, 0);

  const ca_previ_ht_promo_client = users.filter(x => isDateBetween(dateDebut?.value, dateFin?.value, x.dossier.date_envoie)).filter(x => (x.roles.role_client && (['envoye', 'valide'].includes(x.dossier.etat) || x.dossier.etat === 'archive'))).reduce((r, x) => {
    return r + x.dossier.promo_client;
  }, 0);
  const ca_previ_ttc_promo_client = users.filter(x => isDateBetween(dateDebut?.value, dateFin?.value, x.dossier.date_envoie)).filter(x => (x.roles.role_client && (['envoye', 'valide'].includes(x.dossier.etat) || x.dossier.etat === 'archive'))).reduce((r, x) => {
    return r + x.dossier.promo_client;
  }, 0);
  const ca_ht_promo_client = users.filter(x => isDateBetween(dateDebut?.value, dateFin?.value, x.dossier.date_envoie)).filter(x => (x.roles.role_client && x.dossier.etat === 'archive')).reduce((r, x) => {
    return r + x.dossier.promo_client;
  }, 0);
  const ca_ttc_promo_client = users.filter(x => isDateBetween(dateDebut?.value, dateFin?.value, x.dossier.date_envoie)).filter(x => (x.roles.role_client && x.dossier.etat === 'archive')).reduce((r, x) => {
    return r + x.dossier.promo_client;
  }, 0);

  const dataPrevi = [
    ["", "€"],
    ["CA", !TTC?.value ? ca_previ_ht_montant : ca_previ_ttc_montant],
    ["Charges commerciaux", !TTC?.value ? ca_previ_ht_presta : ca_previ_ttc_presta],
    ["Charges code promo commerciaux", !TTC?.value ? ca_previ_ht_promo_commercial : ca_previ_ttc_promo_commercial],
    ["Charges code promo clients", !TTC?.value ? ca_previ_ht_promo_client : ca_previ_ttc_promo_client],
  ];

  const benef_previ = (!TTC?.value ? ca_previ_ht_montant : ca_previ_ttc_montant) - (!TTC?.value ? ca_previ_ht_presta : ca_previ_ttc_presta) - (!TTC?.value ? ca_previ_ht_promo_commercial : ca_previ_ttc_promo_commercial) - (!TTC?.value ? ca_previ_ht_promo_client : ca_previ_ttc_promo_client);

  const dataReel = [
    ["", "€"],
    ["CA", !TTC?.value ? ca_ht_montant : ca_ttc_montant],
    ["Charges commerciaux", !TTC?.value ? ca_ht_presta : ca_ttc_presta],
    ["Charges code promo commerciaux", !TTC?.value ? ca_ht_promo_commercial : ca_ttc_promo_commercial],
    ["Charges code promo clients", !TTC?.value ? ca_ht_promo_client : ca_ttc_promo_client],
  ];

  const benef_reel = (!TTC?.value ? ca_ht_montant : ca_ttc_montant) - (!TTC?.value ? ca_ht_presta : ca_ttc_presta) - (!TTC?.value ? ca_ht_promo_commercial : ca_ttc_promo_commercial) - (!TTC?.value ? ca_ht_promo_client : ca_ttc_promo_client);


  const optionsPrevi = {
    title: "Chiffre d'affaire prévisionnel " + (!TTC?.value ? "HT" : "TTC"),
    colors: ["#F5A623", "#7F7F7F", "#C9C9C9", "#EFEFEF"],
    pieHole: 0.4,
    is3D: false,
    pieSliceText: 'value',
    width: "100%",
    height: "300px",
    chartArea: {
      left: 0,
      top: "5%",
      width: "100%",
      height: "80%"
    },
    legend: {
      position: "bottom",
      textStyle: {
        fontSize: 14,
        alignment: "center",
        whiteSpace: "pre",
      },
      maxLines: 100,
    },
  };

  const optionsReel = {
    title: "Chiffre d'affaire " + (!TTC?.value ? "HT" : "TTC"),
    colors: ["#F5A623", "#7F7F7F", "#C9C9C9", "#EFEFEF"],
    pieHole: 0.4,
    is3D: false,
    pieSliceText: 'value',
    width: "100%",
    height: "300px",
    chartArea: {
      left: 0,
      top: "5%",
      width: "100%",
      height: "80%"
    },
    legend: {
      position: "bottom",
      textStyle: {
        fontSize: 14,
        alignment: "center",
        whiteSpace: "pre",
      },
      maxLines: 100,
      legend: "wrap",
    },
  };

  return (
    <>
      <div className='m-6 grid grid-cols-12 gap-x-4 shrink-0 p-6 max-w-4xl mx-auto bg-white my-shadow'>
        <div className='col-span-12 w-full mb-6 text-center'>
          <h1>Chiffre d'affaires</h1>
        </div>
        <div className='col-span-6 w-full mb-6 text-center'>
          <Chart
            chartType="PieChart"
            data={dataReel}
            options={optionsReel}
          />
          Bénéfice: {benef_reel} €
        </div>
        <div className='col-span-6 w-full mb-6 text-center'>
          <Chart
            chartType="PieChart"
            data={dataPrevi}
            options={optionsPrevi}
          />
          Bénéfice prévisionnel: {benef_previ} €
        </div>

        <div className='col-span-4 w-full mb-4 grid'>
          <WidgetDatePicker state={dateDebut} setState={setDateDebut} id={'date_debut'} text={"Date début"} />
        </div>

        <div className='col-span-4 w-full mb-4 grid'>
          <WidgetDatePicker state={dateFin} setState={setDateFin} id={'date_fin'} text={"Date fin"} />
        </div>

        <div className='col-span-4 w-full mb-4 pt-2 pl-2'>
          <WidgetCheckbox state={TTC} setState={setTTC} id={'ttc'} text={"TTC"} value={false} />
        </div>
      </div>
    </>
  );
}

export default Compta;